/**
 * Fixes period parameter format to ensure consistent API calls
 * 
 * @param {Object} params - The parameters object containing potential period parameter
 * @returns {Object} A copy of params with fixed period format
 */
export function fixPeriodParameter(params) {
    const fixedParams = {...params}
    
    // If period exists as an array, join with || instead of +
    if (Array.isArray(fixedParams?.period)) {
        fixedParams.period = fixedParams.period.join('||')
    }
    
    return fixedParams
}
  